<div class="tutorial" (click)="toggleTutorial(true);event()">
  <div class="icon"><mat-icon>info</mat-icon></div>
  <div class="text">{{text}}</div>
</div>

<div *ngIf="showTutorial" class="tutorial-wrapper">
  <div class="video-wrapper">
    <button mat-icon-button class="close-icon" (click)="toggleTutorial(false)"><mat-icon>close</mat-icon></button>
    <div class="video-section embed-responsive embed-responsive-16by9">
      <iframe class="embed-responsive-item" [src]="tutorialUrl | safeUrl" [title]="title" frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen>
      </iframe>
    </div>
  </div>
</div>
